import React, {Fragment} from "react";
import {connect} from "react-redux";
import {displayErrors} from "../../libs/utils";
import {Loading} from "../../libs/loading";
import {Alert, Table} from "antd";
import {loadIPAddressMapData} from "../../actions/ip_addresses";
import "/node_modules/flag-icons/css/flag-icons.min.css";


class IPAddressMap extends React.Component {
    state = {
        dataLoaded: false,
        loadingData: true,
        locations: [],
        subnets: []
    };

    componentDidMount() {
        if(!this.state.dataLoaded && this.state.loadingData) {
            this.props.loadIPAddressMapData((res) => {
                this.setState({ dataLoaded: true, loadingData: false, locations: res.data.locations, subnets: res.data.subnets, counts: res.data.counts });
            }, (err) => {
                this.setState({ dataLoaded: true, loadingData: false });

                if(typeof err.response !== 'undefined') {
                    displayErrors(err.response.data);
                }
            });
        }
    }

    render() {
        if(this.state.loadingData) {
            return <div className='text-center'><Loading /></div>;
        }

        const columns = [
            { title: 'Country', dataIndex: 'country', render: (item, record) => <span><span className={'fi fi-' + record.country_code.toLowerCase()}></span> {record.country}</span> },
            { title: 'City', dataIndex: 'city' },
            { title: 'Total', dataIndex: 'ip_address_count', align: 'center' },
            { title: 'A classes', dataIndex: 'a_classes', align: 'center' },
            { title: 'B classes', dataIndex: 'b_classes', align: 'center' },
            { title: 'C classes', dataIndex: 'c_classes', align: 'center' },
        ];

        return(
            <Fragment>
                <Alert showIcon type='info' message='IP address availability is based on the addresses currently assigned to your IP groups. Please note that the information on this page updates in real time, so availability in the locations listed below may change at any time.' />
                <br />
                <Table
                    dataSource={this.state.subnets}
                    size='small'
                    rowKey={item => item.city} pagination={false}
                    columns={columns} summary={() => {
                    return <Table.Summary.Row>
                        <Table.Summary.Cell index={1}/>
                        <Table.Summary.Cell index={2} />
                        <Table.Summary.Cell index={3} align='center'>{this.state.counts.ip_address_count}<br /><small>IP addresses</small></Table.Summary.Cell>
                        <Table.Summary.Cell index={4} align='center'>{this.state.counts.a_classes_count}<br /><small>A classes</small></Table.Summary.Cell>
                        <Table.Summary.Cell index={5} align='center'>{this.state.counts.b_classes_count}<br /><small>B classes</small></Table.Summary.Cell>
                        <Table.Summary.Cell index={6} align='center'>{this.state.counts.c_classes_count}<br /><small>C classes</small></Table.Summary.Cell>
                    </Table.Summary.Row>;
                }} />
            </Fragment>
        );
    }
}

export default connect(null, { loadIPAddressMapData })(IPAddressMap);